const REQUIRED_COMPONENTS = require('../../util/constants').GOOGLE_ADDRESS.REQUIRED_COMPONENTS;

/**
 * @param {Object} place Google place
 * @returns {string} street name
 */
function getStreetName(place) {
    const component = place.address_components.find((component) => {
        return component.types.includes('route') || component.types.includes('premise');
    });

    return component ? component.short_name : '';
}

/**
 * @param {Object} place Google place
 * @returns {string} street number
 */
function getStreetNumber(place) {
    const component = place.address_components.find((component) => {
        return component.types.includes('street_number');
    });

    return component ? component.long_name : '';
}

/**
 * @param {Object} place Google place
 * @returns {string} neighborhood
 */
function getNeighborhood(place) {
    const component = place.address_components.find((component) => {
        return component.types.includes('sublocality_level_1') || component.types.includes('sublocality');
    });

    return component ? component.long_name : '';
}

/**
 * @param {Object} place Google place
 * @returns {string} postal code
 */
function getPostalCode(place) {
    const component = place.address_components.find((component) => {
        return component.types.includes('postal_code');
    });

    return component ? component.long_name : '';
}

/**
 * @param {Object} place Google place
 * @returns {string} city
 */
function getCity(place) {
    const component = place.address_components.find((component) => {
        return component.types.includes('locality');
    });

    return component ? component.long_name : '';
}

/**
 * @param {Object} place Google place
 * @returns {string} state
 */
function getState(place) {
    const component = place.address_components.find((component) => {
        return component.types.includes('administrative_area_level_1');
    });

    return component ? component.short_name : '';
}

/**
 * Concatenates components model into a formatted string
 * @param {Object} componentsModel componentsModel
 * @returns {string} Address name
 */
function getAddressName (componentsModel) {
    return `${componentsModel.streetName} ${componentsModel.streetNumber}`;
}

/**
 * Concatenates components model into a formatted string
 * @param {Object} componentsModel componentsModel
 * @returns {string} Address details
 */
function getAddressDetails (componentsModel) {
    const addressDetails = `${componentsModel.streetName} ${componentsModel.streetNumber}, ${componentsModel.neighborhood}, ${componentsModel.postalCode} ${componentsModel.city}, ${componentsModel.state}`;
    return addressDetails.split(' ,').join('');
}

/**
 * Formats the components array from Google and extracts the address name and details
 * @param {Object} place Google place object
 * @returns {Object} addressName and addressDetails
 */
function formatAddressComponents (place) {
    const componentsModel = {
        streetName: getStreetName(place),
        streetNumber: getStreetNumber(place),
        neighborhood: getNeighborhood(place),
        postalCode: getPostalCode(place),
        city: getCity(place),
        state: getState(place)
    }

    const addressDetails = getAddressDetails(componentsModel);
    let addressName = getAddressName(componentsModel);

    if(addressName.length <= 1) {
        addressName = addressDetails;
    }

    return {
        addressName,
        addressDetails,
        zipCode: componentsModel.postalCode,
        stateCode: componentsModel.state
    }
}

/**
 * Gets address components
 * @param {Object} place Google place object
 * @returns {Object} addressName and addressDetails
 */
function getAddressComponents (place) {
    const componentsModel = {
        streetName: getStreetName(place),
        streetNumber: getStreetNumber(place),
        neighborhood: getNeighborhood(place),
        postalCode: getPostalCode(place),
        city: getCity(place),
        state: getState(place)
    }

    return componentsModel;
}

/**
 * Validates the Google address components required for a delivery address
 * @param {Object} componentsModel address components model
 * @returns {Object} validation result and missing component names
 */
function validateRequiredComponents (componentsModel) {
    const missing = REQUIRED_COMPONENTS.filter((componentName) => {
        const value = componentsModel && componentsModel[componentName];
        return typeof value !== 'string' || !value.trim();
    });

    return {
        isValid: missing.length === 0,
        missing
    };
}

module.exports = {
    formatAddressComponents,
    getAddressComponents,
    validateRequiredComponents
};
